module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.1c209e5b6c053b628839.js");
};